module.exports = __webpack_public_path__ + "static/media/agree.b4be17b0.png";